import React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { Breadcrumbs } from '../../atoms/breadcrumbs/breadcrumbs';
import { BackButton } from '../../atoms/back-button/back-button';
import { Arrow } from '../../atoms/arrow/arrow';
import { StyledBackButtonContainer } from './landing-breadcrumbs.style';
import { getBreadcrumbsPath } from '../../sections/landing-breadcrumbs/landing-breadcrumbs';
import { LocaleConfigContext } from '../../../contexts/locale-config/locale-config';
import { IPageProps } from '@interfaces';
interface IProps {
    pageProps: IPageProps;
}

export const LandingBreadcrumbs = ({ pageProps }: IProps) => {
    const localeConfig = React.useContext(LocaleConfigContext);

    const modulesData = pageProps?.modulesData;
    const landingPage = pageProps?.getLandingPage;

    const paths = getBreadcrumbsPath(landingPage, modulesData, localeConfig);

    const theme = useTheme();
    const isMobileView = useMediaQuery(theme.breakpoints.down('sm'));
    const lastPath = paths.slice(-2, -1)[0];

    return isMobileView ? (
        <StyledBackButtonContainer>
            <BackButton href={lastPath.url}>{lastPath.title}</BackButton>
        </StyledBackButtonContainer>
    ) : (
        <Breadcrumbs
            paths={paths}
            variant="light"
            separator={<Arrow size="S" orientation="right" style={{ fill: 'white' }} />}
        />
    );
};
